<template>
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  	<circle cx="24" cy="24" r="20" :style="{ fill: color }"/>
  	<path fill="#ffffff" d="M27.2,23.4c0.4,0.3,0.4,0.9,0,1.2l-1.7,1l1.9,3.3l5.8-3.4c1.2-0.7,1.2-2.4,0-3.1l-5.8-3.4l-1.9,3.3L27.2,23.4z"/>
  	<path fill="#ffffff" d="M21,21c0-0.5,0.6-0.9,1-0.6l1.7,1l1.9-3.3l-5.8-3.4c-1.2-0.7-2.6,0.2-2.6,1.5V23H21V21z"/>
  	<path fill="#ffffff" d="M19.8,33.4l5.8-3.4l-1.9-3.3l-1.7,1c-0.4,0.3-1-0.1-1-0.6v-2h-3.8v6.8C17.2,33.2,18.6,34,19.8,33.4z"/>
  </svg>
</template>

<script>
export default {
  props: ['color'],
};
</script>



// WEBPACK FOOTER //
// play.svg.vue?6259bfae